import { render, staticRenderFns } from "./ys_shuang.vue?vue&type=template&id=59548062&scoped=true"
import script from "./ys_shuang.vue?vue&type=script&lang=js"
export * from "./ys_shuang.vue?vue&type=script&lang=js"
import style0 from "./ys_shuang.vue?vue&type=style&index=0&id=59548062&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59548062",
  null
  
)

export default component.exports